// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabActivitiesSortablePhase-moduledragHandle__RqSF4 RequestProfileTabActivitiesDragHandle-moduleRequestProfileTabActivitiesDragHandle__t8gKJ";
var _2 = "RequestProfileTabActivitiesSortablePhase-modulesortablePhase__UFMTR";
export { _1 as "dragHandle", _2 as "sortablePhase" }
